import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import {
	GET_METARADAR_REFRESH_STATUS_QUERY,
	GET_METARADAR_STATE_QUERY,
	TRIGGER_METARADAR_REFRESH_MUTATION,
} from '@app/model/metaradar/service/MetaradarGraphQLQueries';
import { MetaradarStateSnapshot } from '@app/model/metaradar/MetaradarStateSnapshot';
import { MetaradarRefreshStatus } from '@app/model/metaradar/MetaradarRefreshStatus';

class MetaradarService {

	public static getMetaradarStateSnapshot(companyHotelId: number) {
		return GraphQLExecutor.execute<MetaradarStateSnapshot>(GET_METARADAR_STATE_QUERY, { companyHotelId });
	}

	public static getMetaradarRefreshStatus(companyHotelId: number) {
		return GraphQLExecutor.execute<MetaradarRefreshStatus>(GET_METARADAR_REFRESH_STATUS_QUERY, { companyHotelId });
	}

	public static triggerMetaradarRefresh({ companyHotelId }: { companyHotelId: number }) {
		return GraphQLExecutor.execute<MetaradarRefreshStatus>(TRIGGER_METARADAR_REFRESH_MUTATION, { companyHotelId });
	}

}

export default MetaradarService;
